import { QUERY_KEYS } from "@forwardflow/helpers/utils/constants";
import SubscriptionService from "@forwardflow/services/SubscriptionService";
import { PaginationQueryParams } from "@forwardflow/types";
import useSWR from "swr";

export const useSubscriptionPackageLists = (
  queryParams: PaginationQueryParams,
) => {
  const response = useSWR(
    [QUERY_KEYS.SUBSCRIPTION_PACKAGES, { ...queryParams }],
    () => SubscriptionService.getSubscriptionLists(queryParams)
  );
  return {
    ...response,
  };
};

